export const trimField = (field) =>
  typeof field === "string" ? field.trim() : field;

export const trimFieldsData = (data) => {
  const newData = {};
  for (let field in data) {
    if (typeof data[field] === "string") {
      newData[field] = data[field].trim();
    } else {
      console.log(newData[field]);
      newData[field] = data[field];
    }
  }
  return newData;
};

export const splitStringMainLetter = (str, separator = "_") => {
  const arr = str.split(separator);
  arr.forEach((word, index) => {
    arr[index] = word[0].toUpperCase() + word.slice(1);
  });
  return arr.join(" ");
};

/* export const downloadCSV = (url) => {
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // window.URL.revokeObjectURL(url); // For blob instead of direct URL
};
 */
export const downloadCSV = async (url, filename = "file.csv") => {
  const response = await fetch(url);
  const blob = await response.blob();

  const blobUrl = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  window.URL.revokeObjectURL(blobUrl);
};
